import TimeWrapper from "../components/TimeWrapper";

import watch from "../assets/Watch-01.svg";
import { useEffect, useState } from "react";
import Motivation from "../components/Motivation";
import Navbar from "../components/Navbar/Navbar";
import RedHand from "../assets/red-bar.png";

const targetStartDate = new Date(
  process.env.REACT_APP_START_TIME || "2024-06-07 08:30:00"
);
const targetEndDate = new Date(
  process.env.REACT_APP_END_TIME || "2024-06-09 08:30:00"
);

function Home() {
  const [rotation, setRotation] = useState(0);
  const [motivation, setMotivation] = useState({});
  const [time, setTime] = useState({
    days: 0,
    hours: 0,
    minute: 0,
    second: 0,
  });

  useEffect(() => {
    const intervalId = setInterval(() => {
      const currentDate = new Date();
      if (currentDate >= targetStartDate && currentDate < targetEndDate) {
        let diff = targetEndDate - currentDate;

        let diffInSec = diff / 1000;
        let second = Math.floor(diffInSec % 60);
        let minute = Math.floor(diffInSec / 60) % 60;
        const hours = Math.floor(diffInSec / (60 * 60)) % 24;
        const days = Math.floor(diffInSec / (60 * 60 * 24));
        setRotation((prev) => prev + 1);

        setTime({
          days,
          hours,
          minute,
          second,
        });
      } else {
        setTime({
          days: 0,
          hours: 0,
          minute: 0,
          second: 0,
        });
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const fetchData = async () => {
    try {
      const res = await fetch("https://type.fit/api/quotes");
      const data = await res.json();
      const randomQuote = getRandomQuote(data);
      setMotivation(randomQuote);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const getRandomQuote = (arr = []) => {
    console.log(arr.length);
    if (!arr) return {};

    const randomNumber = Math.floor(Math.random() * arr.length);
    return arr[randomNumber];
  };

  return (
    <div className="page-container">
      <div className="wrapper">
        <div className="header">
          <span className="page-title">KIST HACKATHON</span>
          <Navbar />

          <Motivation text={motivation.text} author={motivation.author} />
        </div>

        <div className="content">
          <TimeWrapper time={time} />
        </div>
      </div>

      <div className="watch-container">
        <img
          className="watch"
          src={watch}
          alt=""
          style={{
            transform: `rotateZ(${rotation}deg)`,
          }}
        ></img>
      </div>

      <div className="red-hand-wrapper">
        <img className="red-hand" src={RedHand} alt=""></img>
      </div>
    </div>
  );
}

export default Home;
